import { visibilityIdsLookupSelector } from "@components/DataGrid/hooks/features/rowVisibilitySelection/gridRowVisibilitySelector";
import { createSelector } from "@components/DataGrid/utils/createSelector";
import { gridFilteredRowsLookupSelector, GridRowId, gridRowTreeSelector, gridSortedRowIdsSelector } from "@mui/x-data-grid-premium";

// TODO v8: Use `createSelectorV8`
export function getVisibilityPropsSelector(groupId: GridRowId, autoSelectParents: boolean) {
  return createSelector(
    gridRowTreeSelector,
    gridSortedRowIdsSelector,
    gridFilteredRowsLookupSelector,
    visibilityIdsLookupSelector,
    (rowTree, sortedRowIds, filteredRowsLookup, rowVisibilityLookup) => {
      const groupNode = rowTree[groupId];
      if (!groupNode || groupNode.type !== 'group') {
        return {
          isIndeterminate: false,
          isChecked: rowVisibilityLookup[groupId] === groupId,
        };
      }

      if (rowVisibilityLookup[groupId] === groupId) {
        return {
          isIndeterminate: false,
          isChecked: true,
        };
      }

      let selectableDescendantsCount = 0;
      let selectedDescendantsCount = 0;
      const startIndex = sortedRowIds.findIndex((id) => id === groupId) + 1;
      for (
        let index = startIndex;
        index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth;
        index += 1
      ) {
        const id = sortedRowIds[index];
        if (filteredRowsLookup[id] !== false) {
          selectableDescendantsCount += 1;
          if (rowVisibilityLookup[id] !== undefined) {
            selectedDescendantsCount += 1;
          }
        }
      }
      return {
        isIndeterminate:
          selectedDescendantsCount > 0 &&
          (selectedDescendantsCount < selectableDescendantsCount ||
            rowVisibilityLookup[groupId] === undefined),
        isChecked: autoSelectParents
          ? selectedDescendantsCount > 0
          : rowVisibilityLookup[groupId] === groupId,
      };
    },
  );
}
